export { default } from './HoldsStatus.jsx';



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/HoldsStatus/index.js